<!--  -->
<template>
  <div class="amall-login-box">
    <div class="container" :class="isPassword ? 'right-panel-active' : ''">
      <!-- Sign In -->
      <div class="container__form container--signin">
        <form action="#" class="form" id="form2">
          <div class="form__title">
            <div class="text-left">
              <img
                style="width: 110px"
                src="https://amall360-2.oss-cn-hangzhou.aliyuncs.com/amall360-2/images/1481812258022625280.png"
                alt=""
              />
            </div>
            <div
              style="margin-top:6px"
              class="
                amall-type
                text-black text-20
                padding-bottom
                margin-bottom
                text-left
              "
            >
              账号登录艾工单后台
            </div>
          </div>
          <input
            type="text"
            placeholder="请输入账号"
            v-model="phone"
            class="input"
          />
          <a-select
            size="large"
            :placeholder="
              phone && !shopList.length ? '该手机号还未注册账户' : '请选择店铺'
            "
            v-model="defaultSelectShop"
            style="width: 100%; height: 51.78px"
            @change="handleChange"
          >
            <a-select-option
              v-for="(item, index) of shopList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
          <input
            style="margin-bottom: 10px"
            type="password"
            placeholder="请输入密码"
            v-model="password"
            class="input"
          />
          <div
            style="width: 100%; padding: 0 24px; margin-bottom: 45px"
            class="flex justify-between align-center text-14 text-yellow"
          >
            <div class="l-hand-change" @click="loginEdit('forget')">
              忘记密码?
            </div>
            <div class="l-hand-change" @click="loginEdit()">账户注册</div>
          </div>
          <div class="btn" style="width: 100%; margin: 0" @click="loginByPwd">
            登 录
          </div>
        </form>
      </div>
      <!-- Sign Up -->
      <div class="container__form container--signup">
        <form action="#" class="form" id="form1">
          <div class="form__title">
            <div class="text-left">
              <img
                style="width: 110px"
                src="https://amall360-2.oss-cn-hangzhou.aliyuncs.com/amall360-2/images/1481812258022625280.png"
                alt=""
              />
            </div>
            <div
            style="margin-top:6px"
              class="
                amall-type
                text-black text-20
                padding-bottom
                margin-bottom
                text-left
              "
            >
              验证码登录艾工单后台
            </div>
          </div>
          <input
            type="text"
            style="height: 54px"
            placeholder="请输入账号"
            v-model="phone"
            class="input"
          />
          <a-select
            size="large"
            :placeholder="
              phone && !shopList.length ? '该手机号还未注册账户' : '请选择店铺'
            "
            v-model="defaultSelectShop"
            style="width: 100%; height: 51.78px"
            @change="handleChange"
          >
            <a-select-option
              v-for="(item, index) of shopList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
          <div class="amall-box-code">
            <input
              type="text"
              style="margin-bottom: 10px"
              v-model="code"
              placeholder="验证码"
              class="input"
            />
            <div
              class="amall-code flex-center text-yellow l-hand-change"
              v-if="!reg_is_getcode"
              @click="reg_getCode"
            >
              获取验证码
            </div>
            <div class="amall-code flex-center text-yellow" v-else>
              {{ seconed }}s
            </div>
          </div>
          <div
            style="width: 100%; padding: 0 24px; margin-bottom: 45px"
            class="flex justify-between align-center text-14 text-yellow"
          >
            <div class="l-hand-change" @click="loginEdit('forget')">
              忘记密码?
            </div>
            <div class="l-hand-change" @click="loginEdit()">账户注册</div>
          </div>
          <div
            class="btn"
            @click="loginByPhone"
            style="width: 100%; margin-top: 0"
          >
            登 录
          </div>
        </form>
      </div>
      <!-- Overlay -->
      <div class="container__overlay">
        <div class="overlay">
          <div class="overlay__panel overlay--left">
            <div>
              <img
                style="width: 363px"
                src="https://amall360-2.oss-cn-hangzhou.aliyuncs.com/amall360-2/images/1481814007156445184.png"
                alt=""
              />
            </div>
            <div
              class="btn flex-center text-18"
              id="signIn"
              style="width: 243px"
              @click="isPassword = false"
            >
              密码登录
              <img
                class="margin-left-xs"
                style="width: 28px; margin-bottom: 5px"
                src="../assets/icon/jiantou@2x.png"
                alt=""
              />
            </div>
          </div>
          <div class="overlay__panel overlay--right">
            <div>
              <img
                style="width: 363px"
                src="https://amall360-2.oss-cn-hangzhou.aliyuncs.com/amall360-2/images/1481814007156445184.png"
                alt=""
              />
            </div>
            <div
              class="btn flex-center text-18"
              id="signUp"
              style="width: 243px"
              @click="isPassword = true"
            >
              验证码登录
              <img
                class="margin-left-xs"
                style="width: 28px; margin-bottom: 5px"
                src="../assets/icon/jiantou@2x.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="amall-service-bottom"
        @mouseleave="show = false"
        @mouseenter="show = true"
      >
        <transition name="fade">
          <div v-if="show" class="amall-top-phone">400-880-8190</div>
        </transition>
        <div class="amall-bottom-text">
          <img
            style="width: 20px; margin-right: 4px"
            src="https://amall360-2.oss-cn-hangzhou.aliyuncs.com/amall360-2/images/1481790020951085056.png"
            alt=""
          />
          平台服务
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginIn } from "@/service/login.js";
import { mobile_message } from "@/service/user_h.js";
import { addColor } from "../utils/addColor.js";
import { shop_list } from "@/service/shop_h.js";
import { reg_getCode } from "@/service/tools";
import * as utils from "@/utils/utils";
export default {
  name: "",
  data() {
    return {
      isPassword: false,
      phone: "",
      password: "",
      shopId: "",
      code: "",
      shopList: [],
      defaultSelectShop: undefined,
      selectShopInfo: {},
      seconed: 60,
      reg_is_getcode: false,
      show: false
    };
  },
  created() {
    let _this = this;
    this.$watch(
      "phone",
      utils.debounce((newValue, oldValue) => {
        if (newValue) {
          _this.checkShopByPhone();
        }
      }, 500)
    );
    document.onkeydown = function(e) {
      let key = window.event.keyCode;
      if (_this.$route.path == "/demandLogin") {
        if (key == 13) {
          if (!_this.isPassword) {
            _this.loginByPwd();
          } else {
            _this.loginByPhone();
          }
        }
      }
    };
  },
  methods: {
    loginByPwd() {
      var that = this;
      var obj = {
        username: this.phone,
        password: this.password,
        code: ""
      };
      if (utils.isNull(this.phone) || utils.isNull(this.password)) {
        that.$message.error("账号和密码不能为空");
        return;
      }
      if (utils.isNull(this.shopId)) {
        that.$message.error("请先选择服务店");
        return;
      }

      localStorage.setItem("amallSystemId", this.shopId);
      localStorage.setItem("amallShopType", this.selectShopInfo.shopType); //1 智慧舒适家  2艾工单
      localStorage.setItem(
        "amallShopInfo",
        JSON.stringify(this.selectShopInfo)
      );
      loginIn(obj)
        .then(res => {
          if (res.code == 20000) {
            this.$message.success(res.message);
            this.loginSuccess();
          } else {
            that.$message.error(res.message);
          }
        })
        .catch(err => {
          that.$message.error(res.message);
        });
    },
    loginSuccess() {
      this.$router.push("/");
    },
    loginByPhone() {
      var that = this;
      var obj = {
        username: this.phone,
        password: "",
        code: this.code
      };
      if (utils.isNull(this.code)) {
        that.$message.error("请输入验证码");
        return;
      }
      localStorage.setItem("amallSystemId", this.shopId);
      localStorage.setItem("amallShopType", this.selectShopInfo.shopType); //1 智慧舒适家  2艾工单
      localStorage.setItem(
        "amallShopInfo",
        JSON.stringify(this.selectShopInfo)
      );
      loginIn(obj).then(res => {
        if (res.code == 20000) {
          this.$message.success(res.message);
          this.loginSuccess();
        } else {
          that.$message.error(res.message);
        }
      });
    },
    loginEdit(status) {
      if (status == "forget") {
        this.$router.push("/forgetPassword");
      } else {
        this.$router.push("./register?type=2");
      }
    },
    // 根据输入的手机号码，查询对应的商户
    checkShopByPhone() {
      var obj = {
        mobile: this.phone
      };
      shop_list(obj).then(res => {
        if (res.flag) {
          let suitList = [];
          res.data &&
            res.data.forEach(item => {
              if (item.shopType == 2) {
                suitList.push(item);
              }
            });
          this.shopList = suitList;
          if (utils.isNull(suitList)) {
            this.defaultSelectShop = undefined;
            this.shopId = ""; 
            this.selectShopInfo = {};
          } 
          if (!utils.isNull(res.data)) {
            this.defaultSelectShop = suitList[0].name;
            this.shopId = suitList[0].id;
            this.selectShopInfo = suitList[0];
          }
        } else {
          this.shopList = [];
          this.shopId = "";
          this.selectShopInfo = {};
          this.defaultSelectShop = undefined;
        }
      });
    },
    // 手机号登入 获取手机验证码
    reg_getCode() {
      let that = this;
      if (utils.isPhone(this.phone)) {
        reg_getCode({ phone: that.phone, tag: 0 }).then(res => {
          if (res.flag) {
            that.reg_is_getcode = true;
            that.reg_timer = setInterval(function() {
              if (that.seconed == 0) {
                that.reg_is_getcode = false;
                that.seconed = 60;
                clearInterval(that.reg_timer);
              } else {
                that.seconed -= 1;
              }
            }, 1000);
            that.$message.success(res.message);
          } else {
            that.$message.error(res.message);
            return;
          }
        });
      } else {
        that.$message.error("手机号格式不正确");
      }
    },
    handleChange(id) {
      this.shopId = id;
      this.shopList.forEach(item => {
        if (id == item.id) {
          this.selectShopInfo = item;
        }
      });
    }
  },
  mounted() {
    document.title = "艾工单";
    addColor(2);
  }
};
</script>
<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.amall-login-box {
  align-items: center;
  background-color: #fff;
  background: url(https://amall360-2.oss-cn-hangzhou.aliyuncs.com/amall360-2/images/1458264412724006912.jpg);
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  display: grid;
  height: 100vh;
  width: 100vw;
  place-items: center;
  z-index: 1;
}
.container {
  background-color: #fff;
  border-radius: 21px;
  box-shadow: 0 0.9rem 1.7rem rgba(0, 0, 0, 0.25),
    0 0.7rem 0.7rem rgba(0, 0, 0, 0.22);
  height: 558px;
  width: 906px;
  overflow: hidden;
  position: relative;
  margin-bottom: 80px;
}
.form__title {
  width: 100%;
  height: 125px;
}

.container__form {
  height: 100%;
  position: absolute;
  top: 0px;
  transition: all 0.6s ease-in-out;
}

.container--signin {
  left: 0;
  width: 50%;
  z-index: 2;
}

.container.right-panel-active .container--signin {
  transform: translateX(100%);
}

.container--signup {
  left: 0;
  opacity: 0;
  width: 50%;
  z-index: 1;
}

.container.right-panel-active .container--signup {
  -webkit-animation: show 0.6s;
  animation: show 0.6s;
  opacity: 1;
  transform: translateX(100%);
  z-index: 5;
}

.container__overlay {
  height: 100%;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 0;
  transition: transform 0.6s ease-in-out;
  width: 50%;
  z-index: 100;
}

.container.right-panel-active .container__overlay {
  transform: translateX(-100%);
}

.overlay {
  // background-color: var(--lightblue);
  background: url(https://amall360-2.oss-cn-hangzhou.aliyuncs.com/amall360-2/images/1458264412724006912.jpg);
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  left: -100%;
  position: relative;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
  width: 200%;
}

.container.right-panel-active .overlay {
  transform: translateX(50%);
}

.overlay__panel {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: absolute;
  text-align: center;
  padding-top: 164px;
  top: 0;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
  width: 50%;
}

.overlay--left {
  transform: translateX(-20%);
}

.container.right-panel-active .overlay--left {
  transform: translateX(0);
}

.overlay--right {
  right: 0;
  transform: translateX(0);
}

.container.right-panel-active .overlay--right {
  transform: translateX(20%);
}

.btn {
  background: linear-gradient(-25deg, #fea52a, #fec60b);
  color: var(--amall-white);
  height: 54px;
  line-height: 54px;
  border-radius: 54px;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.1rem;
  // padding: 0 4rem;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
}

.btn {
  margin-top: 1.5rem;
}

.btn:active {
  transform: scale(0.95);
}

.btn:focus {
  outline: none;
}

.form {
  background-color: var(--amall-white);
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 47px;
  height: 100%;
  text-align: center;
}

.input {
  height: 54px !important;
  padding-left: 20px;
  width: 100%;
  border: 1px solid transparent;
  border-radius: 54px;
  background: #f7f5fb;
  margin-bottom: 24px;
}
.input:focus {
  outline: none;
}
@-webkit-keyframes show {
  0%,
  49.99% {
    opacity: 0;
    z-index: 1;
  }

  50%,
  100% {
    opacity: 1;
    z-index: 5;
  }
}

@keyframes show {
  0%,
  49.99% {
    opacity: 0;
    z-index: 1;
  }

  50%,
  100% {
    opacity: 1;
    z-index: 5;
  }
}
.ant-select {
  height: 54px;
  margin-bottom: 24px;
}
.amall-service-bottom {
  position: fixed;
  z-index: 1000;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
}
.amall-top-phone {
  width: 148px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  margin-bottom: 20px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  position: relative;
  font-size: 20px;
  z-index: 100000;
}
.amall-bottom-text {
  width: 129px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 38px;
  background: rgba(0, 0, 0, 0.15);
  margin: 0 auto;
  cursor: pointer;
}
.amall-top-phone::after {
  content: " ";
  width: 15px;
  height: 10px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -30px;
  border: 15px solid rgba(0, 0, 0, 0.15);
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.container__form >>> .ant-select-selection {
  border: 1px solid transparent;
  background: #f7f5fb;
  border-radius: 54px;
  padding-left: 10px;
  padding-right: 20px;
}
.container__form >>> .ant-select-arrow {
  right: 20px;
}
.container__form >>> .ant-select-selection--single,
.container__form >>> .ant-select-lg .ant-select-selection__rendered {
  height: 54px !important;
  line-height: 54px;
}
.amall-box-code {
  width: 100%;
  position: relative;
}
.amall-code {
  position: absolute;
  width: 100px;
  height: 54px;
  top: 0;
  right: 0px;
  text-align: center;
}
/* input placeholder style */
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #bfbfbf;
  font-size: 16px;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #bfbfbf;
  font-size: 16px;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #bfbfbf;
  font-size: 16px;
}

input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #bfbfbf;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue